export function normalizePageData(data) {
  const result = data && data.result

  if (result && Array.isArray(result.results)) {
    return {
      rows: result.results,
      count: Number(result.count || result.results.length || 0),
    }
  }

  if (Array.isArray(result)) {
    return {
      rows: result,
      count: result.length,
    }
  }

  if (data && Array.isArray(data.results)) {
    return {
      rows: data.results,
      count: Number(data.count || data.results.length || 0),
    }
  }

  return {
    rows: [],
    count: 0,
  }
}
